import { FaSolidStop } from "solid-icons/fa";
import type { VoidComponent } from "solid-js";
import { PulsingColoredCircle } from "./styled";

const Recording: VoidComponent<{ disabled: boolean }> = (props) => {
	return (
		<>
			<PulsingColoredCircle delay={1} opacity="50" disabled={props.disabled}>
				<PulsingColoredCircle delay={0.6} opacity="50">
					<PulsingColoredCircle delay={0.4} opacity="50">
						<PulsingColoredCircle delay={0.2} opacity="50">
							<FaSolidStop />
						</PulsingColoredCircle>
					</PulsingColoredCircle>
				</PulsingColoredCircle>
			</PulsingColoredCircle>
		</>
	);
};
export default Recording;
